import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'dva';
import styles from './ImportContent.module.scss';
import SidebarBody from '../SidebarBody';
import ImportDropzone from '../../ImportDropzone';
import ImportFileList from '../DataManager/ImportSection/ImportFileList';
import FeatureListItem from '../../FeatureListItem';
import dayjs from 'dayjs';

function ImportForm(props) {
  return (
    <>
      { props.importError ? 
      <>
        <p className={styles.importError}>Your file failed to import.</p>
        <p className={styles.importErrorMessage}>{props.importError}</p>
        <p className={styles.importError}>Please contact us at reachus@gohunt.com for assistance.</p>
      </> :
      <p className={styles.importDesc}>Add waypoints, tracks, and other data from your GPS or other map platforms.</p>
      }
      { props.acceptedFiles && props.acceptedFiles.length > 0 ?
        <ImportFileList files={props.acceptedFiles} /> : 
        <ImportDropzone />
      }
    </>
  );
}

function ImportFeaturesList(props) {
  return (
    <>
      <h2 className={ styles.successTitle }>{'Import ' + dayjs().format('MM/DD/YYYY h:mm a')}</h2>
      <p className={ styles.successCount }>{props.importedFeatures.length} items</p>
      <ul>
        { props.importedFeatures.map((feature, i) => {
            return <FeatureListItem checkboxDisabled={true} feature={feature} key={i} showVisibilityIcon={false}/>;
          })
        }
      </ul>
    </>
  );
}

function ImportBody(props) {
  return (
    <SidebarBody>
      { !props.importError && props.importedFeatures && props.importedFeatures.length > 0 ?
        <ImportFeaturesList {...props} /> :
        <ImportForm {...props} />
      }
    </SidebarBody>
  );
}

ImportFeaturesList.propTypes = {
  acceptedFiles: PropTypes.array,
  loading: PropTypes.bool,
  importError: PropTypes.string,
  importedFeatures: PropTypes.array,
};

ImportForm.propTypes = {
  acceptedFiles: PropTypes.array,
  loading: PropTypes.bool,
  importError: PropTypes.string,
  importedFeatures: PropTypes.array,
};

ImportBody.propTypes = {
  acceptedFiles: PropTypes.array,
  loading: PropTypes.bool,
  importError: PropTypes.string,
  importedFeatures: PropTypes.array,
};

export default connect (({ importSidebar }) => {
  return {
    importedFeatures: importSidebar.importedFeatures,
    importError: importSidebar.importError,
    acceptedFiles: importSidebar.acceptedFiles,
    loading: importSidebar.loading,
  };
})(ImportBody);
// export default ImportBody;